import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react'
import { init, refreshToken } from '../../auth/handleTokens';
import { constants } from '../../constants';
import NotificationContext from '../toasts/NotificationContext';
import ContactsGroup from './ContactsGroup';

const Groups = (props) => {
  const toggle = props.toggleSidebar ? '215px' : '10px'
  const {showNotification} = useContext(NotificationContext);
  const [groupSelect, setGroupSelect] = useState(null);

  const [groups, setGroups] = useState([]);
  const [nameGroup, setNameGroup] = useState('');
  const [newGroup, setNewGroup] = useState(false);
  const [start, setStart] = useState(true);

  const getGroups =  async() => {
    try {
      const token = window.localStorage.getItem('at');
      const URL = constants.test_host + '/user/groups/list';
      const {data} = await axios.get(URL, {headers: {'Content-Type': 'application/json', 'authorization': `Bearer ${token}`}, withCredentials: true})
      setGroups(data.groups);
      
    } catch (error) {
        if(error.response.data.statusCode ===401){
          const result= await refreshToken();
          if(!result) {
            window.localStorage.clear();
            return window.location.href= '/login';
          }else{
            getGroups();
          }
          
        } else {
          window.localStorage.clear();
          return window.location.href = '/login;'
        }
      }
    }

  useEffect(() =>{
    getGroups();
  },[newGroup])
   
   const saveGroup = async() => {
     try {
      const result = await init();
      if(!result) return window.location.href = '/login'
      const URL = constants.test_host + '/user/create-group';
      const token= window.localStorage.getItem('at');
      const {data} = await axios.post(URL, {name: nameGroup}, {headers: {'Content-Type': 'application/json', 'authorization': `Bearer ${token}`}, withCredentials: true});
      showNotification('success', data.message);
      setNewGroup(!newGroup);
      setNameGroup('');
      
    } catch (error) {
      showNotification('failed', error.response.data.message)
    }
   }

   const selectionGroup = (e, s) => {
    setGroupSelect(e.offsetParent.parentElement.children[1].innerHTML);
    if(!s) return setStart(false);
    if(s) return deleteGroup();
   }

   const deleteGroup = async(e) => {
    const result = await init();
    if(!result) return window.location.href = '/login'
    const URL = constants.test_host + '/user/delete-group/'+ groupSelect;
      const token= window.localStorage.getItem('at');
      const {data} = await axios.delete(URL, {headers: {'Content-Type': 'application/json', 'authorization': `Bearer ${token}`}, withCredentials: true});
      setNewGroup(!newGroup);
      showNotification('success', 'Grupo Eliminado.');
   }

   const tableGroups = groups.map((item, index) =>
  
    <tr key={item._id}>
      <td>{index + 1}</td>
      <td style={{textAlign: 'justify'}}>{item.name}</td>
      <td style={{textAlign: 'justify'}}>{item.members}</td>
      <td id={item._id} style={{textAlign: 'justify'}}><a title='Ver Grupo' className='btn-sm btn btn-primary' id={item._id} href="#contactsGroupModal" role="button" data-bs-toggle="modal" onClick={(e)=> selectionGroup(e.target, false) }>Ver</a> <a title='Eliminar grupo' className='btn-sm btn btn-primary' onClick={(e) => selectionGroup(e.target, true)}><i className="fas fa-trash-alt"></i></a></td>
    </tr>
)

  return (
    <div className="content-wrapper content" style={{ marginLeft: `${toggle}`, transition: "all 0.5s",  paddingLeft: '20px'}} >
      <div className='container'>
      <h5 className='subtitle'>Grupos</h5>
      <form className="row g-2">
            <div style={{fontSize: 'medium'}} className="col-auto form-floating form-outline">
              
              <input
                type="text"
                className="form-control"
                id="nameGroup"
                name='nameGroup'
                required
                value={nameGroup}
                onChange= {({target}) => setNameGroup(target.value.toUpperCase())}
                placeholder= 'Nombre del grupo'
                style={{maxHeight: '40px', fontSize:'smaller'}}
              />
              <label style={{fontSize: 'small'}} htmlFor="nameLink">
                Nombra tu Grupo
              </label>
            </div>
            

            <div className="col-auto">
              <button type='button' onClick={saveGroup} className="btn btn-sm btn-primary mb-3">
                Registrar
              </button>
            </div>
          </form>

          <hr />

          <div>
          <h6 style={{textAlign: 'left', paddingLeft:'20px', fontSize:'smaller'}}>Links Registrados:</h6>
          <table className="table table-striped" style={{fontSize:'small', textAlign: 'justify'}}>
            <thead>
              <tr>
                <th>#Id</th>
                <th>Nombre</th>
                <th>Miembros</th>
                <th>Acción</th>
              </tr>
            </thead>
            <tbody>
              {tableGroups}
            </tbody>
          </table>
        </div>

      </div>

      <div id="contactsGroupModal" className="modal fade" tabIndex="-1">
          <div className="modal-dialog">
            <div className='modal-content font-mulish'>
              <ContactsGroup groupSelect= {groupSelect} start= {start} setNewGroup={setNewGroup} />
            </div>
          </div>
        </div>
      
    </div>
  )
}

export default Groups
